import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineRecipe,
  defineSlotRecipe,
} from "@chakra-ui/react"

export const buttonRecipe = defineRecipe({
  variants: {
    variant: {
      primary: {
        backgroundColor: "main",
        color: "light",
        _hover: {
          backgroundColor: "tertiary",
        },
        _disabled: {
          backgroundColor: "main",
          _hover: {
            backgroundColor: "main",
          },
        },
      },
      secondary: {
        backgroundColor: "secondary",
        color: "dark",
        _hover: {
          backgroundColor: "#E2E8F0",
        },
        _disabled: {
          backgroundColor: "secondary",
          _hover: {
            backgroundColor: "secondary",
          },
        },
        _dark: {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          color: "light",
          _hover: {
            backgroundColor: "rgba(255, 255, 255, 0.16)",
          },
          _disabled: {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            _hover: {
              backgroundColor: "rgba(255, 255, 255, 0.08)",
            },
          },
        },
      },
      close: {
        _hover: {
          backgroundColor: "rgba(0, 0, 0, 0.06)",
        },
        _dark: {
          _hover: {
            backgroundColor: "rgba(255, 255, 255, 0.06)",
          },
        }
      },
      danger: {
        backgroundColor: "danger",
        color: "light",
        _hover: {
          backgroundColor: "#E32727",
        },
      },
      input: {
        px: 3,
        py: 2.5,
        borderWidth: "1px",
        borderRadius: "md",
        borderColor: "border",
        _focusVisible: {
          outline: "2px solid",
          outlineColor: "chakra-colors-blue-500",
          outlineOffset: "2px",
        },
        _invalid: {
          borderColor: "red.500",
        }
      }
    },
  },
})

export const containerRecipe = defineRecipe({
  base: {
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
  },
})

export const inputRecipe = defineRecipe({
  base: {
    _focus: {
      outlineColor: "main !important",
      borderColor: "main !important",
    },
    _focusVisible: {
      outlineColor: "main !important",
      borderColor: "main !important",
    },
  },
})

export const dialogRecipe = defineSlotRecipe({
  slots: ["content"],
  base: {
    content: {
      _dark: {
        backgroundColor: "darkSlate",
      }
    }
  },
})

export const tabsRecipe = defineSlotRecipe({
  slots: ["trigger"],
  variants: {
    variant: {
      outline: {
        trigger: {
          _dark: {
            color: "light",
          },
          _selected: {
            borderTopRadius: "5px !important",
            color: "main !important",
          }
        }
      }
    }
  },
})

export const tableRecipe = defineSlotRecipe({
  slots: ["columnHeader", "root", "cell"],
  base: {
    root: {
      width: "100%",
    },
    columnHeader: {
      textTransform: "uppercase",
      _dark: {
        color: "dim",
      },

      "&:has(.sortable)": {
          display: "flex",
          alignItems: "center",
      },
    }
  },
  variants: {
    variant: {
      special: {
        root: {
          backgroundColor: "transparent",
        },
        columnHeader: {
          textTransform: "none",
          "&:first-child": {
            paddingLeft: 0,
          }
        },
        cell:{
          "&:not(:first-child)": {
            textAlign: "center",
          },
          "&:first-child": {
            paddingLeft: 0,
          }
        },
      }
    }
  }
})

export const checkboxRecipe = defineSlotRecipe({
  slots: ["root", "control"],
  base: {
    root: {
      textAlign: "center",
    },
    control: {
      marginRight: "5px !important",
      _checked: {
        backgroundColor: "main !important",
        borderColor: "main !important",
        color: "secondary !important",
      },
    },
  },
  variants: {
    variant: {
      strong: {
        control: {
          borderColor: "dim",
        }
      }
    }
  }
})

export const selectRecipe = defineSlotRecipe({
  slots: ["content"],
  base: {
    content: {
      _dark: {
        backgroundColor: "darkSlate",
      },
    },
  },
})


export const pagnationRecipe = defineSlotRecipe({
  slots: ["ellipsis"],
  base: {
    ellipsis: {
      borderRadius:"full",
    },
  },
})

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        main: { value: "var(--main)" },
        secondary: { value: "var(--secondary)" },
        tertiary: { value: "var(--tertiary)" },
        success: { value: "#48BB78" },
        danger: { value: "#E53E3E" },
        light: { value: "#FAFAFA" },
        dark: { value: "#1A202C" },
        darkSlate: { value: "#252D3D" },
        dim: { value: "#A0AEC0" },
        dimHover: { value: "#76808e" },
        hoverDanger: { value: "#cd1c1c" },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          DEFAULT: {
            value: { _dark: "#1A202C" },
          },
        },
      },
    },
    slotRecipes: {
      dialog: dialogRecipe,
      menu: dialogRecipe,
      drawer: dialogRecipe,
      table: tableRecipe,
      checkbox: checkboxRecipe,
      tabs: tabsRecipe,
      select: selectRecipe,
      pagination: pagnationRecipe,
    },
    recipes: {
      container: containerRecipe,
      button: buttonRecipe,
      input: inputRecipe,
    }, 
  },
  globalCss: {
    "*": {
      _dark: {"--chakra-colors-border": "rgba(255, 255, 255, 0.16)"},
      "--chakra-colors-border": "#E2E8F0" ,
    },
  },
  preflight: true,
})

export const system = createSystem(defaultConfig, config)